<form [formGroup]="form" class="form-b4a" (submit)="submit()">
  <p-fieldset legend="Detalhes">
    <ng-container formGroupName="grade">
      <span class="p-float-label">
        <input id="title" pInputText formControlName="title" />
        <label for="title">Atributo</label>
      </span>
      <span class="p-float-label">
        <input id="value" pInputText formControlName="value" />
        <label for="value">Valor</label>
      </span>
    </ng-container>
    <span class="p-float-label">
      <input id="sku" pInputText formControlName="sku" />
      <label for="sku">SKU</label>
    </span>
    <span class="p-float-label" formGroupName="stock">
      <p-inputNumber
        id="quantity"
        inputId="quantity"
        formControlName="quantity"
        [min]="0"
      />
      <label for="quantity">Estoque</label>
    </span>
    <span class="p-float-label">
      <input id="EAN" pInputText formControlName="EAN" />
      <label for="EAN">EAN</label>
    </span>
    <span class="p-float-label">
      <p-inputNumber
        id="weight"
        inputId="weight"
        formControlName="weight"
        [min]="0"
        [minFractionDigits]="2"
        [maxFractionDigits]="2"
        suffix="g"
      />
      <label for="weight">Peso *</label>
    </span>
    <span class="p-float-label">
      <p-inputMask id="daysOfUse" formControlName="daysOfUse" mask="9?999">
      </p-inputMask>
      <label for="daysOfUse">Dias de uso</label>
    </span>
    <span class="p-float-label">
      <p-dropdown
        formControlName="groupId"
        inputId="groupId"
        [options]="groups"
        optionValue="value"
        optionLabel="name"
        appendTo="body"
        [autoDisplayFirst]="true"
      />
      <label for="groupId">Grupo</label>
    </span>
    <span class="p-float-label">
      <p-dropdown
        formControlName="label"
        inputId="label"
        [options]="labels"
        optionValue="value"
        optionLabel="name"
        appendTo="body"
        [autoDisplayFirst]="true"
      />
      <label for="label">Label</label>
    </span>
    <span class="p-float-label">
      <p-dropdown
        formControlName="validity"
        inputId="validity"
        [options]="validities"
        optionValue="value"
        optionLabel="name"
        appendTo="body"
        [autoDisplayFirst]="true"
      />
      <label for="validity">Vigente</label>
    </span>
    <span class="p-float-label">
      <p-inputNumber
        id="costPrice"
        inputId="costPrice"
        formControlName="costPrice"
        prefix="R$"
        readonly
      />
      <label for="costPrice">Custo</label>
    </span>
    <span class="p-input-checkbox">
      <p-checkbox
        formControlName="published"
        [binary]="true"
        inputId="published"
      />
      <label for="published">Publicado?</label>
    </span>
  </p-fieldset>
  <p-fieldset legend="Preço" formGroupName="price">
    <span class="p-float-label">
      <p-inputNumber
        id="fullPrice"
        formControlName="fullPrice"
        prefix="R$"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
        [min]="0.01"
        (onInput)="recalculatePrices()"
        (onBlur)="recalculatePrices()"
        (onKeyDown)="recalculatePrices()"
      />
      <label for="fullPrice">Preço cheio *</label>
    </span>
    <span class="p-float-label">
      <p-inputNumber
        (onInput)="recalculatePrices()"
        (onBlur)="recalculatePrices()"
        (onKeyDown)="recalculatePrices()"
        id="price"
        formControlName="price"
        prefix="R$"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
        [min]="0.01"
      />
      <label for="price">Preço *</label>
    </span>
    <span class="p-float-label">
      <p-inputNumber
        (onInput)="recalculatePrices()"
        (onBlur)="recalculatePrices()"
        (onKeyDown)="recalculatePrices()"
        id="subscriberDiscount"
        type="number"
        suffix="%"
        formControlName="subscriberDiscountPercentage"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
        [max]="100"
        [min]="0"
      />
      <label for="subscriberDiscount">Desconto de assinante *</label>
    </span>
    <span class="p-float-label">
      <p-inputNumber
        id="subscriberPrice"
        prefix="R$"
        formControlName="subscriberPrice"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
      />
      <label for="subscriberPrice">Preço de assinate *</label>
    </span>
    <span class="p-float-label">
      <p-inputNumber
        id="fullPriceDiscountPercentage"
        formControlName="fullPriceDiscountPercentage"
        suffix="%"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
      />
      <label for="fullPriceDiscountPercentage">Desconto preço cheio *</label>
    </span>
  </p-fieldset>
  <p-fieldset legend="Tags">
    <span class="p-float-label full-w">
      <p-chips
        formControlName="tagsCollection"
        [separator]="chipRegex"
        inputId="tagsCollection"
        name="tagsCollection"
        [addOnTab]="true"
        [addOnBlur]="true"
        [showClear]="true"
        (onAdd)="addCollectionTag($event)"
        (onBlur)="addCollectionTag($event)"
        (onClear)="form.controls['tagsCollection'].setValue([])"
      />
      <label for="tagsCollection">Tags de collection</label>
      <small>Utilize "," ou "Enter" para adicionar</small>
    </span>
    <span class="p-float-label full-w">
      <p-chips
        formControlName="tagsProfile"
        [separator]="chipRegex"
        inputId="tagsProfile"
        name="tagsProfile"
        [addOnTab]="true"
        [addOnBlur]="true"
        [showClear]="true"
        (onAdd)="addProfileTag($event)"
        (onBlur)="addProfileTag($event)"
        (onClear)="form.controls['tagsProfile'].setValue([])"
      />
      <label for="tagsProfile">Tags de perfil</label>
      <small>Utilize "," ou "Enter" para adicionar</small>
    </span>
    <span class="p-float-label full-w">
      <p-chips
        formControlName="tagsSupply"
        [separator]="chipRegex"
        inputId="tagsSupply"
        name="tagsSupply"
        [addOnTab]="true"
        [addOnBlur]="true"
        [showClear]="true"
        (onAdd)="addSupplyTag($event)"
        (onBlur)="addSupplyTag($event)"
        (onClear)="form.controls['tagsSupply'].setValue([])"
      />
      <label for="tagsSupply">Tags de supply</label>
      <small>Utilize "," ou "Enter" para adicionar</small>
    </span>
    <span class="p-float-label">
      <p-autoComplete
        [suggestions]="filterOptionsAvailable"
        formControlName="filters"
        filterBy="description"
        optionLabel="id"
        appendTo="body"
        [lazy]="false"
        [multiple]="true"
        (completeMethod)="searchFilters($event)"
        [showClear]="true"
        (onClear)="form.controls['filters'].setValue([])"
      />
      <label for="filters">Fitros</label>
    </span>
  </p-fieldset>

  <p-fieldset legend="Metadata" formGroupName="metadata">
    <span class="p-float-label">
      <input id="title" type="text" pInputText formControlName="title" />
      <label for="title">Título *</label>
    </span>
    <span class="p-float-label">
      <input
        id="description"
        type="text"
        pInputText
        formControlName="description"
      />
      <label for="description">Descrição *</label>
    </span>
  </p-fieldset>

  <p-fieldset legend="Descrições" formGroupName="description">
    <span class="p-input-editor">
      <label for="productSummary"> Descrição </label>
      <p-editor
        [readonly]="!permission"
        [style]="{ height: '320px' }"
        formControlName="description"
        id="description"
        #description
      />
    </span>
    <span class="p-input-editor">
      <label for="differentials"> Diferenciais </label>
      <p-editor
        [readonly]="!permission"
        [style]="{ height: '320px' }"
        formControlName="differentials"
        id="differentials"
        #differentials
      />
    </span>
    <span class="p-input-editor">
      <label for="whoMustUse"> Quem deve usar </label>
      <p-editor
        [readonly]="!permission"
        [style]="{ height: '320px' }"
        formControlName="whoMustUse"
        id="whoMustUse"
        #whoMustUse
      />
    </span>
    <span class="p-input-editor">
      <label for="howToUse"> Como usar </label>
      <p-editor
        [readonly]="!permission"
        [style]="{ height: '320px' }"
        formControlName="howToUse"
        id="howToUse"
        #howToUse
      />
    </span>
    <span class="p-input-editor">
      <label for="brand"> Sobre a marca </label>
      <p-editor
        [readonly]="!permission"
        [style]="{ height: '320px' }"
        formControlName="brand"
        id="brand"
        #brand
      />
    </span>
    <span class="p-input-editor">
      <label for="ingredients"> Ingredientes </label>
      <p-editor
        [readonly]="!permission"
        [style]="{ height: '320px' }"
        formControlName="ingredients"
        id="ingredients"
        #ingredients
      />
    </span>
    <span class="p-input-editor">
      <label for="purpose">Propósito</label>
      <p-editor
        [readonly]="!permission"
        [style]="{ height: '320px' }"
        formControlName="purpose"
        id="purpose"
        #purpose
      />
    </span>
  </p-fieldset>

  <p-fieldset legend="Imagens">
    <ng-container *ngIf="variant.images; else noImageTemplate">
      <app-drag-drop-list
        [list]="variant.images"
        [template]="imageTemplate"
        [permission]="false"
      >
        <ng-template #imageTemplate let-image="data">
          <p-button
            [rounded]="true"
            severity="danger"
            [text]="true"
            icon="pi pi-trash"
            pTooltip="Excluir imagem"
            tooltipPosition="bottom"
            type="button"
            (onClick)="confirmDeleteImage(image, $event)"
            *ngIf="permission"
          />
          <img style="width: 100%" [src]="image" alt="" />
        </ng-template>
      </app-drag-drop-list>
    </ng-container>
    <ng-template #noImageTemplate>
      <span>Nenhuma imagem adicionada ao produto</span>
    </ng-template>
  </p-fieldset>

  <div class="form-footer">
    <div class="info">
      <div>
        <p>
          *Última alteração em:
          {{ variant.updatedAt || variant.createdAt | date: 'short' }}
        </p>
      </div>
    </div>
    <div class="action">
      <p-button
        *ngIf="permission"
        type="submit"
        pRipple
        label="Salvar"
        severity="primary"
        [disabled]="!form.valid"
      >
      </p-button>
    </div>
  </div>
</form>
<p-toast />
